/*
* @Author: 王春岩 <Bolt>
* @Date:   2016-12-21 16:30:41
* @Last Modified by:   Bolt
* @Last Modified time: 2016-12-21 21:06:54
*/

'use strict';

import './index.less';

import Vue from 'vue';

import Announcement from './components/Announcement.vue';

/* eslint-disable */
new Vue({
    el: '.copyright',
    template: '<div is="Announcement" :arg0="arg0">123</div>',
    data: {
        arg0: window._qiwa.site_global.annoncementList
    },
    components: {
        Announcement
    }
});



// WEBPACK FOOTER //
// ./src/modules/footer/index.js